import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { CrewTypeViewModel } from 'ab-viewModels/crewType.viewModel';

import { isAllowed } from '@acceligentllc/shared/utils/auth';

import type { RootState } from 'af-reducers';

import PagePermissions from 'ab-enums/pagePermissions.enum';

import Pill from 'af-components/Pills/Pill';
import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';

interface OwnProps {
	crewType: CrewTypeViewModel;
	toEdit: (id: number) => void;
	deleteCrewType: (id: number) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

class CrewTypePreview extends React.PureComponent<Props> {

	edit = () => {
		const { crewType, toEdit } = this.props;

		if (!crewType.id) {
			throw new Error('No crew type to edit');
		}
		toEdit(crewType.id);
	};

	deleteCrewType = () => {
		const { crewType, deleteCrewType } = this.props;

		if (!crewType.id) {
			throw new Error('No crew type to delete');
		}
		deleteCrewType(crewType.id);
	};

	modalBody = (crewType: CrewTypeViewModel) => (
		<>
			You are about to delete crew type <b>{crewType.name}</b>.
			<br />
			Are you sure you want to continue?
		</>
	);

	renderPrefix = (crewType: CrewTypeViewModel) => {
		const { canViewForeman } = this.props;

		if (!crewType.foremanEnabled || !canViewForeman) {
			return null;
		}

		return (
			<Tooltip
				message={(
					<div className={styles['crew-lead-tooltip']}>
						<div className={styles['crew-lead-tooltip__title']}>Crew Lead</div>
						<div>Marked as Crew Lead for Crew Type</div>
					</div>
				)}
				placement="top"
			>
				<span className={styles['crew-lead-indicator']} />
			</Tooltip>
		);
	};
	render() {
		const { crewType } = this.props;

		return (
			<Pill
				color={crewType.color}
				item={crewType}
				labelKey="name"
				modalBody={this.modalBody}
				modalTitle="Delete Crew Type"
				onClick={this.edit}
				removeItem={this.deleteCrewType}
				renderPrefix={this.renderPrefix}
			/>
		);
	}
}

function mapStateToProps(state: RootState) {
	const { user: { companyData, userData } } = state;

	if (!userData || !companyData) {
		throw new Error('User not logged in');
	}

	const { isCompanyAdmin, permissions } = companyData;
	const { role } = userData;

	const canViewForeman = isAllowed(
		PagePermissions.COMPANY.FOREMAN.VIEW,
		permissions,
		isCompanyAdmin,
		role
	);

	return {
		canViewForeman,
	};
}

const connector = connect(mapStateToProps);

export default connector(CrewTypePreview);
